/**
 * @fileoverview ESM view of the ONE plural-key selector (Q-R8CLOSE-2).
 * @module @puffin-core/i18n-bootstrap/esm/pluralKeys
 *
 * **There is no logic in this file.** The implementation lives once, in CJS, at
 * `../pluralKeys.js` — see that file for the rule (i18next 26's, measured) and for why the source
 * direction is CJS.
 *
 * Destructured default import, not `export { x } from …`: the latter is a STATIC named import
 * that bundlers cannot always satisfy through a CJS `module.exports`. Same form as
 * `./intlLocaleFor.js` and `./formatterCache.js`.
 */

import pluralKeys from '../pluralKeys.js';

export const {
  PLURAL_CATEGORIES,
  endsInPluralCategory,
  needsPluralHandling,
  pluralCandidateKeys,
  selectPluralKey,
} = pluralKeys;
